import React, {Component} from 'react';
import Grid from '@react/react-spectrum/Grid/js/Grid';
import GridColumn from '@react/react-spectrum/Grid/js/GridColumn';
import GridRow from '@react/react-spectrum/Grid/js/GridRow';
import Heading from '@react/react-spectrum/Heading';
import { Translate } from 'react-redux-i18n';
import { reduxForm, getFormValues } from 'redux-form';
import DataSection from '../../comps/DataSection/DataSection';
import formFields from '../config/formFields';
import { TnC } from '../utils/api/dummyTnC';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import Well from '@react/react-spectrum/Well';
import Wait from '@react/react-spectrum/Wait/js/Wait';

class ProgramAgreement extends Component{

    constructor(props)
    {
        super(props);
        window.scrollTo(0,0);
        this.state = {
            sectionValidation : {section15 : false},
            TnCAvailable : false,
            termCount : 0
        }
    }

    componentDidMount(){
        this.props.connector.getTnC(this.loadTerms, this.props.formStates.billingCountry);
    }

    updateValidation = (name,value) => {
        let sectionValidation = this.state.sectionValidation;
        sectionValidation[name] = value;
        this.setState({sectionValidation:sectionValidation});
    }

    loadTerms = (terms) => {
        sessionStorage.setItem("term", JSON.stringify(terms));
        this.setState({TnCAvailable:true});
    }
    
    render(){
        this.props.onValidateChange(Object.values(this.state.sectionValidation).every(Boolean));
        const formName = 'registration';
        let tnC = [];
        let tnCJapanPart2 = [];

        if(this.state.TnCAvailable)
        {
            let temp = JSON.parse(sessionStorage.getItem("term"));
            temp.map((item, counter)=>{
                if(this.props.formStates.preferredLanguage_0 == 'Japanese') {
                    if(counter === 0) {
                        tnC.push(ReactHtmlParser(item));
                    } else {
                        tnCJapanPart2.push(ReactHtmlParser(item));
                    }
                } else {
                    tnC.push(ReactHtmlParser(item));
                }
                return null;
            });
        }

        return <div>
            <Grid>
            <GridRow>
                    <GridColumn size={[12,8,6,6]} offsetSize={[0,2,3,3]}>
                    <GridRow>
                        <GridColumn >
                            <Heading className = "textBold" variant="pageTitle"><Translate value="registration.OnbrdTermsSectionHeader" /></Heading>
                            <p><Translate value="registration.prog_agmt_text" /></p>
                        </GridColumn>
                    </GridRow>
                     
                    <GridRow >
                        <GridColumn>
                        { this.state.TnCAvailable ? <Well className="tnc">
                            <span>
                                {
                                 tnC
                                }
                            </span>
                            <DataSection formStates={this.props.formStates} form={formName} field={formFields.section15} sectionName="section15" updateValidation={this.updateValidation}/>
                            {tnCJapanPart2.length > 0 ? 
                            <span>
                                { tnCJapanPart2 }
                            </span>
                            : null }
                            </Well> : 
                            <div className="agreementWait">
                                <Wait size="L"/>
                            </div>
                        }
                            
                        </GridColumn>
                    </GridRow>
                    </GridColumn>
            </GridRow>
            </Grid>
            </div>
    }
}

ProgramAgreement = reduxForm({
    form:'registration',
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  })(ProgramAgreement);

  const mapStateToProps = (state) => ({
    formStates: getFormValues('registration')(state)
  });
  
const mapDispatchToProps = (dispatch) => ({
  });
  
export default connect(mapStateToProps, mapDispatchToProps)(ProgramAgreement);
